import React from 'react';
import Routes from './Routes';
import "./styles/global";
import {
  createTheme,
  ThemeProvider,
  Theme,
  StyledEngineProvider,
} from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { useSelector } from 'react-redux';
import hyperflowService from './services/hyperflowService';


declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

declare module '@mui/material/styles' {
  interface Palette {
    maintenance: Palette['primary'];
    notDefined: Palette['primary'];
    inactive: Palette['primary'];
    valid: Palette['primary'];
    invalid: Palette['primary'];
    validWithOpenedActions: Palette['primary'];
  }

  interface PaletteOptions {
    maintenance?: PaletteOptions['primary'];
    notDefined?: PaletteOptions['primary'];
    inactive?: PaletteOptions['primary'];
    valid?: PaletteOptions['primary'];
    invalid?: PaletteOptions['primary'];
    validWithOpenedActions?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Badge' {
  interface BadgePropsColorOverrides {
    maintenance: true;
    notDefined: true;
    inactive: true;
    valid: true;
    invalid: true;
    validWithOpenedActions: true;
  }
}

const theme = createTheme({
  palette: {
    primary: { main: "rgb(0, 128, 0)" },
    secondary: { main: "rgb(208, 69, 69)" },
    success: { main: "rgb(0, 41, 132) " },
    maintenance: { main: 'darkblue' },
    notDefined: { main: '#fcbe03' },
    inactive: { main: 'gray' },
    valid: { main: 'green' },
    invalid: { main: '#e57878' },
    validWithOpenedActions: { main: '#fcbe03' },
  },
  components: {
    MuiButton: {
      defaultProps:{
        color: 'inherit',
      }
    }
  }
});



const App = () => {

  const accessId = useSelector((state: any) => state.auth?.selectedAccess?._id || '')

  // Inicializa o Hyperflow quando o usuário está logado
  React.useEffect(() => {
    if (accessId) {
      hyperflowService.initializeWithUser().catch(console.error)
    } else {
      hyperflowService.initializeNoUser().catch(console.error)
    }
  }, [accessId])

  return <>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes />
      </ThemeProvider>
    </StyledEngineProvider>
  </>;
}

export default App;
